module.exports = __webpack_public_path__ + "img/6-2.9c0b8640.png";